// extracted by mini-css-extract-plugin
module.exports = {"root":"bk_bY"};